<script>
export default {
    props: {
        topic: {tpye: Object}
    },
    data() {
        return {
            optionLabel: ["A", "B", "C", "D"]
        }
    },
    methods: {
        getAnswer(val = 0) {
            const topicItem = this.topic
            if ([1,3].includes(topicItem.topic_type)) {
                const index = val ? topicItem.stu_answer : topicItem.topic.options.value

                if (topicItem.topic_type === 1) {
                    return this.optionLabel[index] ?? "未作答"
                }
                if (topicItem.topic_type === 3) {
                    return topicItem.topic.options.option[index] ? topicItem.topic.options.option[index].name : "未作答"
                }
            }
            if (topicItem.topic_type === 2) {
                const answer =  val ? topicItem.stu_answer.map(item => this.optionLabel[item]) : topicItem.topic.options.value.map((item) => this.optionLabel[item]);
                return answer.join("、")
            }
            if (topicItem.topic_type === 4) {
                if (val) {
                    return topicItem.stu_answer.join("、").replace(/、/g, "").length ? topicItem.stu_answer.join("、") : "未作答";
                } else {
                    const fillblank = topicItem.topic.options.option.map((item) => {
                        return item.name ? item.name : item
                    })
                    return fillblank.join("、")
                }
            }
            if (topicItem.topic_type === 5 && val) {
                return  topicItem.stu_answer.trim().length ? topicItem.stu_answer : "未作答"
            }

        }
    }
}
</script>
<template>
    <div class="topic-panel">
        <template v-if="topic.topic_type !== 5">
            <span >正确答案是：</span>
            <span class="blue true bold" >
                {{ getAnswer() }}
            </span>
            <span>&nbsp;&nbsp;学生答案：</span>
            <span class="bold" :class="topic.is_true ? '' : 'red'">
                {{ getAnswer(1) }}
            </span>
            <span>&nbsp;得分：<span style="color: #59ADFF;font-weight: 600;">{{ Number(topic.stu_score) }}</span>&nbsp;&nbsp;分</span>
        </template>
        <template v-else>
            <div class="stu-answer-label">学生答案：
                <span :class="topic.stu_answer.trim().length ? '': 'red'">{{ getAnswer(1) }}</span>
            </div>
            <div class="stu-answer">得分：<span style="color: #59ADFF;font-weight: 600;">{{ Number(topic.stu_score) ? Number(topic.stu_score) : 0 }}</span>&nbsp;&nbsp;分</div>
        </template>
    </div>
</template>
<style lang="scss" scoped>
.blue {
    color: #006EFF;
}
.red {
    color: #f01414;
}
.bold {
    font-weight: 700;
}
.stu-answer  {
    margin-top: 10px;
}
</style>
